import React from 'react';

import { Flex, Image } from '@chakra-ui/react';
import { Add, Button } from '@mesh.ai/rabbit';
import { useQueryClient } from '@tanstack/react-query';
import { loggedInUsersAccessesKey } from 'Deer/hooks/useLoggedInUsersAccessesQuery';
import { useDispatch } from 'react-redux';
import { setShowViewsPanel, setViewAction, VIEWS_ACTIONS } from 'reducers/viewsSlice';

import EmptyView from 'assets/assetsV1/illustrations/deerIllustrations/emptyViews.svg';

import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

const EmptyViews = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const onCreateNewTeam = () => {
    dispatch(setViewAction(VIEWS_ACTIONS.CREATE));
    dispatch(
      setShowViewsPanel({
        onSuccess: () => {
          queryClient.invalidateQueries([loggedInUsersAccessesKey]);
        },
      })
    );
  };
  return (
    <Flex alignItems="center" w="100%" flexDir="column" marginBottom="20px">
      {/* @ts-expect-error src is not string */}
      <Image src={EmptyView} alt="Empty View" w="120px" h="120px" />
      <Flex alignItems="center" justifyContent="center" mt="8px" flexDir="column" w="60%" textAlign="center">
        <TextBodyMedium bold>No custom teams</TextBodyMedium>
        <TextLabel color="text.g2">Create a custom team to refine your data by a specific group.</TextLabel>
      </Flex>
      <Button iconLeft={Add} variant="outline" style={{ marginTop: '12px' }} onClick={onCreateNewTeam}>
        Create new
      </Button>
    </Flex>
  );
};

export { EmptyViews };
